if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const targetId = this.getActiveMediaId();

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${targetId}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });

        let activeMedia = this.querySelector(`[data-media-id="${targetId}"]`);

        // Si l'élément demandé n'est pas trouvé, utiliser la première image
        if (!activeMedia) {
          activeMedia = this.querySelector('[data-media-id]');
        }

        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          // Centrer le visuel actif dans la modale (défilement horizontal). L'ancien calcul
          // `container.scrollLeft = (activeMedia.width - clientWidth)/2` se basait sur la
          // largeur intrinsèque de l'image (pas la position du slide) → la modale restait
          // affichée sur le 1er visuel alors que .active était posé sur le bon.
          requestAnimationFrame(function () {
            activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });
          });

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }

      // Détermine le média à ouvrir.
      // Desktop : comportement d'origine inchangé (id du déclencheur).
      // Mobile : le picto/déclencheur porte un id figé sur la 1re image → on ouvre plutôt
      // le visuel réellement affiché dans la galerie (corrige « le zoom ouvre toujours le
      // premier visuel au lieu de l'image affichée »).
      getActiveMediaId() {
        const openerId = this.openedBy.getAttribute('data-media-id');
        if (window.matchMedia('(min-width: 768px)').matches) return openerId;
        return this.getMobileCurrentMediaId() || openerId;
      }

      getMobileCurrentMediaId() {
        const section = this.id.replace('ProductModal-', '');
        const viewer = document.querySelector(`#GalleryViewer-${section}`);
        if (!viewer) return null;

        const sliderEl = viewer.querySelector('[id^="Slider-"]') || viewer;
        const slides = Array.from(
          sliderEl.querySelectorAll('.product__media-item'),
        ).filter((s) => s.offsetWidth > 0);
        if (!slides.length) return null;

        // Slide visible = celui dont le bord gauche est le plus proche du scroll courant.
        const x = sliderEl.scrollLeft;
        const current = slides.reduce(
          (best, s) =>
            best === null || Math.abs(s.offsetLeft - x) < Math.abs(best.offsetLeft - x)
              ? s
              : best,
          null,
        );
        if (!current) return null;

        // Le déclencheur interne au slide porte l'id média exact utilisé par la modale.
        const toggle = current.querySelector('.product__media-toggle[data-media-id]');
        if (toggle) return toggle.getAttribute('data-media-id');

        const raw = current.getAttribute('data-media-id') || '';
        const prefix = `${section}-`;
        return (raw.startsWith(prefix) ? raw.slice(prefix.length) : raw) || null;
      }
    },
  );
}
